import { useEffect, useRef, useState } from 'react'
import throttle from 'lodash.throttle'

export const useScrolledPosition = () => {
    const [scrolledClass, setScrolledClass] = useState('')
    const lastScrollTop = useRef(0)

    useEffect(() => {
        const handleScroll = throttle(() => {
            const defaultHeaderOffset = 100
            const { scrollTop } = document.documentElement
            if (scrollTop < defaultHeaderOffset) {
                setScrolledClass('')
            } else if (scrollTop < lastScrollTop.current) {
                setScrolledClass('showFixed mobileShowPromoBar')
            } else {
                setScrolledClass('showFixed')
            }

            lastScrollTop.current = scrollTop // Update the last scroll position
        }, 200)

        document.addEventListener('scroll', handleScroll)
        return () => {
            document.removeEventListener('scroll', handleScroll)
        }
    }, [])
    return [scrolledClass, setScrolledClass]
}
